module.exports = __webpack_public_path__ + "static/media/femalerating.6d6ebc2c.svg";